const uRLs = {
    BASE_URL : process.env.REACT_APP_BASE_URL, 
    LOGO_IMAGE:process.env.REACT_APP_LOGO_PATH, 
    COOKIE_NAME:process.env.REACT_APP_COOKIE_NAME,    
    PER_PAGE:process.env.REACT_APP_PER_PAGE,
    TIMEZONE:process.env.REACT_APP_TIMEZONE,
    LOGO_IMAGE1:process.env.REACT_APP_LOGING_IMG_PATH, 
    mapKey:process.env.REACT_APP_MAPKEY
};

export default uRLs;
